export default __webpack_public_path__ + "static/logo-christie-finance-white-aea4b527ef2374d70e69443e41604104.svg";